<script context="module">
  import BlockQuote from "$lib/contentTypes/BlockQuote.svelte";
  import Embed from "$lib/contentTypes/Embed/Embed.svelte";
  import FreeRichTextComponent from "$lib/contentTypes/FreeRichTextComponent.svelte";
  import ImageComponent from "$lib/contentTypes/ImageComponent.svelte";
  import ImageGroup from "$lib/contentTypes/ImageGroup.svelte";
  import CallToActionComponent from "$lib/contentTypes/CallToActionComponent.svelte";
  import ContentGroup from "$lib/contentTypes/ContentGroup.svelte";
  import EmailSignupForm from "$lib/contentTypes/EmailSignupForm.svelte";
  import FundraiseUpElement from "$lib/contentTypes/FundraiseUpElement.svelte";

  export const LAYOUT_COMPONENT_MAP = {
    blockQuote: BlockQuote,
    callToActionComponent: CallToActionComponent,
    contentGroup: ContentGroup,
    emailSignup: EmailSignupForm,
    embed: Embed,
    freeRichTextComponent: FreeRichTextComponent,
    fundraiseUpElement: FundraiseUpElement,
    imageComponent: ImageComponent,
    imageGroup: ImageGroup
  };
</script>

<script>
  import Layout from "$lib/components/Layout.svelte";

  export let data;
</script>

<div class="embedded-content mx-auto max-w-max md:max-w-screen-md lg:max-w-screen-lg">
  <Layout
    items={data.fields.items}
    fillStrategy={data.fields.fillStrategy}
    numberOfColumns={data.fields.numberOfColumns}
    header={data.fields.header}
    componentMap={LAYOUT_COMPONENT_MAP}
  />
</div>
